var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06615 9.99997L8.86615 13.1666L13.9328 6.8333M9.49948 18.8666C8.33509 18.8666 7.18211 18.6373 6.10635 18.1917C5.0306 17.7461 4.05315 17.093 3.2298 16.2696C2.40645 15.4463 1.75334 14.4688 1.30775 13.3931C0.862156 12.3173 0.632813 11.1644 0.632812 9.99997C0.632813 8.83558 0.862156 7.68259 1.30775 6.60684C1.75334 5.53109 2.40645 4.55363 3.2298 3.73029C4.05315 2.90694 5.0306 2.25383 6.10635 1.80824C7.18211 1.36264 8.33509 1.1333 9.49948 1.1333C11.8511 1.1333 14.1063 2.06746 15.7692 3.73029C17.432 5.39311 18.3661 7.64838 18.3661 9.99997C18.3661 12.3516 17.432 14.6068 15.7692 16.2696C14.1063 17.9325 11.8511 18.8666 9.49948 18.8666Z",
    stroke: "black",
    strokeWidth: 1.26667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.d412838dc8115f5ae207b4821701072c.svg";
export { ForwardRef as ReactComponent };